<script setup lang="ts">
  import { useBranchLogo } from '@/entities/Branch';

  interface Props {
    reportDate: string;
    documentTitle?: string;
    documentCode?: string;
    listTitle?: string;
  }

  withDefaults(defineProps<Props>(), {
    documentTitle: 'DADOS',
    documentCode: 'DA05.5',
    listTitle: 'LISTA DE PERMISSÕES',
  });

  const { currentLogoUrl, handleLogoError } = useBranchLogo();
</script>

<template>
  <table
    data-print="header-table"
    class="mb-6 w-full border-collapse"
  >
    <tbody>
      <tr>
        <td
          rowspan="2"
          class="min-w-[220px] w-[308px] border border-record-header-border bg-white-01 px-4 py-6 text-center align-middle max-md:min-w-[180px] max-md:w-[180px]"
        >
          <div class="flex items-center justify-center">
            <img
              :src="currentLogoUrl"
              alt="Logo HTM"
              class="max-w-[170px] max-h-[84px]"
              @error="handleLogoError"
            />
          </div>
        </td>
        <td
          class="border border-record-header-border px-4 py-5 text-center align-middle text-[16px] leading-5 font-semibold text-record-header-text max-md:text-[14px]"
        >
          {{ documentTitle }}
        </td>
        <td
          class="w-40 border border-record-header-border px-3 py-4 text-center align-middle text-sm leading-5 font-semibold text-record-header-text"
        >
          {{ documentCode }}
        </td>
        <td
          class="w-40 border border-record-header-border px-3 py-4 text-center align-middle text-sm leading-5 font-semibold text-record-header-text"
        >
          {{ reportDate }}
        </td>
      </tr>
      <tr>
        <td
          colspan="3"
          class="border border-record-header-border px-4 py-5 text-center align-middle text-[16px] leading-5 font-semibold text-record-header-text max-md:text-[14px]"
        >
          {{ listTitle }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
